import React, { Component } from "react";
import { shareFacebook, shareWhatsapp, openNegishut } from "../Services/Sharing"
import "./Header.scss"

export default class Header extends Component {
  constructor() {
    super()
    this.state = {
      isShareActive: false
    }
    this.activateSharer = this.activateSharer.bind(this);
  }
  activateSharer() {
    this.setState({
      isShareActive: !this.state.isShareActive
    })
  }
  render() {
    return (
      <header>
        <div id="header">
          <div className="padding">
            <div className="container">
              <div className="publisher">
                <a href="https://ynet.co.il/" target="_blank"><div className="logo"></div></a>
                <a href="http://tara.co.il/" target="_blank"><div className="tara"></div></a>
              </div>
              <div className="utils">
                <div className={`share`}>
                  <div onClick={shareWhatsapp} className="whatsapp"></div>
                  <div onClick={shareFacebook} className="facebook"></div>
                  <div onClick={openNegishut} className="negishut"></div>
                </div>
              </div>
            </div>
          </div>
        <div className="mainlogo"></div>
        </div>
      </header>
    );
  }
}


// WEBPACK FOOTER //
// ./src/Components/Header/Header.jsx